import React, { useEffect, useState } from 'react'
import { NuDatePicker, NuInputEmail, NuInputNumber, NuInputText, NuSelect, NuSelectwithSearch, NuTextArea } from '../../../../Components/Utils/NuInput';
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import NuDate from '../../../../Components/Utils/NuDate';
import BreadCrumb from '../../../../Components/Utils/Breadcrumbs';
import axiosInstance from '../../../../Services/axiosCommon';
import { useFormik } from 'formik';
import { notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import * as yup from "yup";
function CreateAccounts() {
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [banks, setBanks] = useState([]);
  let navigate = useNavigate  ();
  const [createNew, setCreateNew] = useState({
    branchId:1,
    accountType:"",
    accountName:"",
    accountNumber:"",
    bankName:"",
    address:"",
    routingNumber:"",
    ifscCode:"",
    swiftBicCode:"",
    micrCode:"",
    contactNumber:"",
    email:""
});

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // firstName: yup.string().required("Name Required"),
      // // dob: yup
      // //   .string()
      // //   .required("Date of Birth Required"),
      // gender: yup.string().required("Gender is Required"),
      // mobileNo: yup
      //   .string()
      //   .required("Mobile Number is required")
      //   .matches(
      //     /^((\\[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
      //     "Enter Valid Mobile Number"
      //   )
      //   .min(9, "Invalid Mobile Number")
      //   .max(10, "Invalid Mobile Number"),
      // email: yup.string().required("Email is required"),
    }),
    onSubmit: async (value, { resetForm }) => {
      value.contactNumber = `${value.contactNumber}`
      axiosInstance.post("/bank/", value)
          .then((res) => {
            if (res?.data?.status === true) {
              // send_notif();
              resetForm();
              navigate(-1);
              api.success({
                message: 'Success',
                description:res.data.msg || 'Accounts created.',
                placement: "bottomRight",
              });
            } else {
              api.error({
                message: `Failed`,
                description: res?.data?.msg || 'Network error',
                placement: "bottomRight",
              });
            }
          })
          .catch((err) => {
            console.log(err);
            api.error({
              message: `Failed`,
              description: err?.data?.msg || 'Network error',
              placement: "bottomRight",
            });
          });
    },
  });

  const bankDropDown = () =>{
    const params = {
      page:1,
      per_page:20,
    };
    axiosInstance.get('/bank/',{ params })
    .then((res)=>{
        let finalArray = [];
        console.log(res?.data?.data,'ddddd');
        let banks = res?.data?.data.bankDetails
        banks.forEach(element => {
            let tempData = {value:element?.bankId, label:element?.bankName};
            finalArray.push(tempData);
        });
        res?.data?.data && setBanks(finalArray);
       })
      .catch(
        (err)=>{
          console.log(err);
        }
      )
}
  useEffect(()=>{
    bankDropDown();    
  },[]);

  return (
    <div className="w-full h-full px-4 py-2">
      {contextHolder}
      <div className="w-full h-[46px]  flex justify-between ">
        <BreadCrumb
          items={[
            { title: <p className=" text-[12px] ">Test</p> },
            { title: <p className=" text-[12px] ">Accounts</p> },
          ]}
        />
        <div className=" flex gap-2">
          <BackButton />
        </div>
      </div>
      <div className=" overflow-y-scroll h-[calc(100%-55px)]">
        <form onSubmit={formik.handleSubmit}>
        <div className=" w-full grid rounded-lg mt-2 mb-6 grid-cols-3">
          <NuSelectwithSearch
              label="Account Type"
              isRequired={true}
              options={[
                // { value: "Bank", label: "Bank" },
                { value: "Current", label: "Current" },
                { value: "Saving", label: "Saving" },
               
              ]}
              formik={formik}
              placeholder="Choose"
              name="accountType"
              width="w-full"
            />
             <NuInputText
                label="Account Name"
                isRequired={true}
                placeholder="Account Name"
                formik={formik}
                name="accountName"
                width="w-full"
            />
           
            <NuInputNumber
              label="Account Number"
              placeholder="0"
              // disable={true}
              formik={formik}
              name="accountNumber"
              width="w-full"
            />
             <NuInputText
                label="Bank Name"
                isRequired={true}
                placeholder="Bank Name"
                formik={formik}
                name="bankName"
                width="w-full"
            />
            {/* <NuInputText
                label="Branch Name"
                isRequired={true}
                placeholder="Branch Name"
                formik={formik}
                name="branchName"
                width="w-full"
            /> */}
            
            <NuInputNumber
              label="Routing Number"
              placeholder="0"
              // disable={true}
              formik={formik}
              name="routingNumber"
              width="w-full"
            />
             <NuInputText
                label="IFSC Code"
                isRequired={true}
                placeholder="IFSC Code"
                formik={formik}
                name="ifscCode"
                width="w-full"
            />
            <NuInputText
                label="SWIFT / BIC Code"
                isRequired={true}
                placeholder="SWIFT / BIC Code"
                formik={formik}
                name="swiftBicCode"
                width="w-full"
            />
            <NuInputText
                label="MIRC Code"
                isRequired={true}
                placeholder="MIRC Code"
                formik={formik}
                name="micrCode"
                width="w-full"
            />
           
            <NuTextArea
                label="Address"
                // isRequired={true}
                placeholder="Address"
                formik={formik}
                name="address"
                width="w-full"
            />
            {/* <NuInputText
                label="Country"
                // isRequired={true}
                placeholder="Country"
                formik={formik}
                name="country"
                width="w-full"
            /> */}

            {/* <NuSelectwithSearch
              label="Province / State"
              isRequired={true}
              options={[
                // { value: "Bank", label: "Bank" },
                { value: "offline", label: "Cash" },
                { value: "online", label: "Online" },
                { value: "cheque", label: "Cheque" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="provinceOrState"
              width="w-full"
            />
            <NuSelectwithSearch
              label="Town / City"
              isRequired={true}
              options={[
                // { value: "Bank", label: "Bank" },
                { value: "offline", label: "Cash" },
                { value: "online", label: "Online" },
                { value: "cheque", label: "Cheque" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="townOrCity"
              width="w-full"
            />
             <NuSelectwithSearch
              label="Postal / Zip Code"
              isRequired={true}
              options={[
                // { value: "Bank", label: "Bank" },
                { value: "offline", label: "Cash" },
                { value: "online", label: "Online" },
                { value: "cheque", label: "Cheque" },
              ]}
              formik={formik}
              placeholder="Choose"
              name="postalOrZipCode"
              width="w-full"
            /> */}
             <NuInputNumber
                label="Contact Number"
                // isRequired={true}
                placeholder="0"
                formik={formik}
                name="contactNumber"
                width="w-full"
              />
            <NuInputEmail
                label="Email"
                // isRequired={true}
                placeholder="Email"
                formik={formik}
                name="email"
                width="w-full"
              />
          
            
{/* {formik.values.transactionMethod == "cheque" && (
              <NuInputNumber
                label="Cheque Number"
                // isRequired={true}
                placeholder="0"
                formik={formik}
                name="chequeNumber"
                width="w-full"
              />
            )} */}

            {/* {(formik.values.transactionMethod == "Bank"||formik.values.transactionMethod == "online") && (
              <NuSelect
                label="Bank Name"
                isRequired={true}
                options={banks}
                placeholder="Choose"
                formik={formik}
                name="bankId"
                width="w-full"
              />
            )} */}
            {/* {(formik.values.transaction_method == "Bank"||formik.values.transaction_method == "Online") && (
              <NuInputText
                label="IFSE"
                isRequired={true}
                placeholder="IFSE"
                formik={formik}
                name="ifse"
                width="w-full"
              />
            )}

            {formik.values.transaction_method == "Bank" && (
              <NuInputText
                label="Transaction Reference"
                isRequired={true}
                placeholder="Transaction Reference"
                formik={formik}
                name="transaction_reference"
                width="w-full"
              />
            )} */}

{/* {formik.values.transaction_method == "Cash" && (
              <NuInputText
                label="Voucher Number"
                isRequired={true}
                placeholder="Voucher Number"
                formik={formik}
                name="voucher_number"
                width="w-full"
              />
            )}

{formik.values.transaction_method == "Online" && (
              <NuInputText
                label="Online Transaction Number"
                isRequired={true}
                placeholder="Online Transaction Number"
                formik={formik}
                name="online_transaction_number"
                width="w-full"
              />
            )} */}

            {/* <div className=" col-span-2">
                <NuTextArea
                label="Comments"
                // isRequired={true}
                placeholder="Comments"
                formik={formik}
                name="comments"
                width="w-full"
              />
              </div> */}
          </div>
          <div className='flex justify-center gap-2'><SubmitButton/><CancelButton handleClick={()=>{navigate(-1)}}/></div>
        </form>
      </div>
    </div>
  );
}
export default CreateAccounts;